import { styled } from '@mui/material';
import { ReactNode } from 'react';
import { PanelEditorSubActionContainer } from '@pages/app/rca/tabs/components/panel-editor-side-sub-action';

export interface PanelEditorSideActionProps {
  icon: ReactNode;
  label: string;
  isOpen: boolean;
  actions: Array<ReactNode>;
  onClick: () => void;
  disabled?: boolean;
}

export enum PanelEditorSideActionType {
  addEndState,
  highlight,
  collapse,
  createAsFocalPoint,
  connect,
  disprove,
  deleteItem,
}

const Container = styled('div')<{ isOpen: boolean; disabled: boolean }>(
  ({ isOpen, disabled, theme: { palette } }) => ({
    '.side-action-button': {
      cursor: !disabled ? 'pointer' : 'default',
      background: isOpen ? palette.common.black : '#F9F9F9',
      color: isOpen ? palette.common.white : '#383838',
      border: 'none',
      minHeight: 75,
      padding: '8px 10px',
      borderRadius: 5,
      fontFamily: 'Roboto',
      fontSize: '11px',
      fontWeight: '400',
      lineHeight: '14px',
      letterSpacing: '0px',
      textAlign: 'left',
      display: 'inline-flex',
      flexDirection: 'column',
      gap: 13,
      svg: {
        height: 18,
        width: 'auto',
        stroke: isOpen ? palette.common.white : '#383838',
      },
      ...(disabled && {
        background: '#e1e1e1',
        color: '#383838',

        svg: {
          stroke: '#383838',
        },
      }),
    },
  })
);

export default function PanelEditorSideAction({
  icon,
  label,
  isOpen,
  onClick,
  disabled,
  actions,
}: PanelEditorSideActionProps) {
  return (
    <Container isOpen={isOpen} disabled={disabled ?? false}>
      <button
        type="button"
        onClick={!disabled ? onClick : () => {}}
        disabled={disabled}
        className="side-action-button"
      >
        {icon}
        <span>{label}</span>
      </button>
      {!disabled ? (
        <PanelEditorSubActionContainer isOpen={isOpen}>
          {actions}
        </PanelEditorSubActionContainer>
      ) : null}
    </Container>
  );
}
